<template>
  <section class="container" id="directory">
    <div class="content-view">
      <div class="section">
        <h2>Directorio</h2>
        <!-- Inicio del panel jefautra -->
        <div class="columns is-centered">
          <div class="column is-two-thirds is-full-mobile">
            <article class="panel">
              <p class="panel-heading primary-background">
                Jefatura de la Unidad
              </p>
              <div class="panel-block is-active">
                <div class="columns is-centered is-full">
                  <div class="column is-full">
                    <p class="has-text-weight-semibold">Lic. José Luis Castillo </p>
                    <p class="is-size-7">
                      Conmutador 55-5687-6858/68/78/88
                      Ext. 1109
                    </p>
                  </div>
                </div>
              </div>
            </article>
          </div>
        </div>
        <!-- Fin del panel jefautra -->
        <!-- Inicio del panel Programas Académicos -->
        <div class="columns is-centered">
          <div class="column is-two-thirds is-full-mobile">
            <article class="panel">
              <p class="panel-heading primary-background">
                Programas Académicos
              </p>
              <div class="panel-block is-active">
                <div class="columns is-centered is-full">
                  <div class="column is-full">
                    <p class="has-text-weight-semibold">Lic. María del Socorro Landeros</p>
                    <p>Técnico Académico</p>
                    <p class="is-size-7">
                      Conmutador 55-5687-6858/68/78/88
                      Ext. 1110
                    </p>
                  </div>
                </div>
              </div>
              <div class="panel-block is-active">
                <div class="columns is-centered is-full">
                  <div class="column is-full">
                    <p class="has-text-weight-semibold">Mtra. Gpe. Laura Ramírez Juárez</p>
                    <p>Técnico Académico</p>
                    <p class="is-size-7">
                      Conmutador 55-5687-6858/68/78/88
                      Ext. 1110
                    </p>
                  </div>
                </div>
              </div>
            </article>
          </div>
        </div>
        <!-- Fin del panel Programas Académicos -->
        <!-- Inicio del panel Selección de Aspirantes -->
        <div class="columns is-centered">
          <div class="column is-two-thirds is-full-mobile">
            <article class="panel">
              <p class="panel-heading primary-background">
                Selección de Aspirantes
              </p>
              <div class="panel-block is-active">
                <div class="columns is-centered is-full">
                  <div class="column is-full">
                    <p class="has-text-weight-semibold">Lic. Adriana Cuéllar Hernández</p>
                    <p>Técnico Académico</p>
                    <p class="is-size-7">
                      Conmutador 55-5687-6858/68/78/88
                      Ext. 1108
                    </p>
                  </div>
                </div>
              </div>
            </article>
          </div>
        </div>
        <!-- Fin del panel Selección de Aspirantes -->
        <!-- Inicio del panel Soporte Técnico en Cómputo -->
        <div class="columns is-centered">
          <div class="column is-two-thirds is-full-mobile">
            <article class="panel">
              <p class="panel-heading primary-background">
                Soporte Técnico en Cómputo
              </p>
              <div class="panel-block is-active">
                <div class="columns is-centered is-full">
                  <div class="column is-full">
                    <p class="has-text-weight-semibold">Ing. Michelle Caterine García Velasco</p>
                    <p>Técnico Académico</p>
                    <p class="is-size-7">
                      Conmutador 55-5687-6858/68/78/88
                      Ext. 1108
                    </p>
                  </div>
                </div>
              </div>
            </article>
          </div>
        </div>
        <!-- Fin del panel Soporte Técnico en Cómputo -->
        <!-- Inicio del panel Secretaria -->
        <div class="columns is-centered">
          <div class="column is-two-thirds is-full-mobile">
            <article class="panel">
              <p class="panel-heading primary-background">
                Secretaria
              </p>
              <div class="panel-block is-active">
                <div class="columns is-centered is-full">
                  <div class="column is-full">
                    <p class="has-text-weight-semibold">Griselda Aguilar Gómez</p>
                    <p class="is-size-7">
                      Conmutador 55-5687-6858/68/78/88
                      Ext. 1111
                      uiap.informes@enp.unam.mx
                    </p>
                  </div>
                </div>
              </div>
            </article>
          </div>
        </div>
        <!-- Fin del panel Secretaria -->
      </div>
    </div>
  </section>
</template>

<script>

export default {
  name: 'Directory',
  data: () => ({
    activeMenu: false,
  }),
  /*
  methods: {
    inactiveMenu() {
      console.log('hola');
    },
  },
  */
};
</script>
<style lang="scss">
  .is-full{
    width: 100%;
  }
  .panel-block{
    line-height: 0.5;
  }

  .panel-block .has-text-weight-semibold{
    line-height: 1.2;
  }
</style>
